import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { Datatype } from '../../../../../../expressions/datatype/Datatype';
import { IAsyncSelectWidget } from '../../IAsyncSelectWidget';

type IInputType = Pick<IAsyncSelectWidget, 'table' | 'outputs'>;

function getColumns(widget: IInputType): ColumnsType<any> {
  const result: ColumnsType<any> = [];

  for (const col of widget.table?.columns ?? []) {
    const output = widget.outputs?.find(o => o.name === col.value);
    const column = {
      title: col.label,
      dataIndex: col.value,
      key: col.value,
      render:
        output?.type.type === Datatype.Date
          ? (value: string) =>
              value ? dayjs(value).format('DD/MM/YYYY') : value
          : undefined,
    };

    result.push(column);
  }

  return result;
}

export function useAsyncServiceTableColumns(
  widget: IInputType,
): ColumnsType<any> {
  const columns = useMemo(() => getColumns(widget), [widget]);
  return columns;
}
